import { type ComponentProps, forwardRef, type ReactNode } from 'react'

import { type ButtonPlain, Placeholder, useLoading } from '@subaio/components'

import { Button } from './Button'
import { IconWrapper } from './IconWrapper'
import { Label } from './Label'
import { Subtitle } from './Subtitle'

export { ButtonLinkList } from './ButtonLinkList'

type Props = {
	label: ReactNode
	subtitle?: ReactNode
	icon?: ReactNode
	tracking?: {
		type: string
		label: string
		target?: string
	}
} & Omit<ComponentProps<typeof ButtonPlain>, 'children' | 'type'>

export const ButtonLink = forwardRef<HTMLButtonElement, Props>(
	({ label, subtitle, icon, onClick, disabled = false, tracking, ...rest }, ref) => {
		const isLoading = useLoading()

		return (
			<Button
				disabled={isLoading || disabled}
				onClick={isLoading ? () => undefined : onClick}
				{...rest}
				ref={ref}
				data-element-type={tracking?.type}
				data-element-label={tracking?.label}
				data-element-target={tracking?.target}
			>
				<Label>
					<Placeholder width='156px'>{label}</Placeholder>
					{subtitle && <Subtitle isDisabled={disabled}>{subtitle}</Subtitle>}
				</Label>
				{icon && <IconWrapper>{!isLoading && !disabled && icon}</IconWrapper>}
			</Button>
		)
	},
)
